export function checklistRecords(questions, queries, findings, activities) {
  const ids = new Set(questions.map((q) => String(q.id)));
  const scopedQueries = queries.filter((q) => ids.has(String(q.inspectionChecklistId)));
  const scopedFindings = findings.filter((f) => ids.has(String(f.questionId)));
  const references = [...questions.map((q) => q.code), ...scopedQueries.flatMap((q) => [q.queryNumber, q.id, q.taskNumber]),
    ...scopedFindings.map((f) => f.findingNumber)].filter(Boolean);
  const escaped = references.map((ref) => String(ref).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const pattern = escaped.length ? new RegExp(`(^|[^a-z0-9])(${escaped.join("|")})(?=$|[^a-z0-9])`, "i") : null;
  return {
    queries: scopedQueries,
    findings: scopedFindings,
    activities: activities.filter((a) => ids.has(String(a.inspectionChecklistId)) || pattern?.test(a.activityNote || "")),
  };
}
